import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { openCookieSettings } from "@/lib/consent";

export const LEGAL_LINKS = [
  { to: "/privacy-policy", label: "Privacy", testid: "privacy" },
  { to: "/terms", label: "Terms", testid: "terms" },
  { to: "/terms#refunds", label: "Refunds", testid: "refunds" },
  { to: "/cookie-policy", label: "Cookies", testid: "cookies" },
  { to: "/accessibility", label: "Accessibility", testid: "accessibility" },
];

export default function LegalLayout({ title, eyebrow, lastUpdated, children }) {
  return (
    <main
      id="main-content"
      data-testid="legal-page"
      className="relative min-h-screen bg-[#0a0a0a] text-zinc-200"
    >
      <header className="border-b border-white/[0.06] bg-[#0a0a0a]/80 backdrop-blur sticky top-0 z-30">
        <div className="max-w-[1100px] mx-auto px-5 md:px-10 py-5 flex items-center justify-between">
          <Link to="/" data-testid="legal-home-link" className="flex items-center gap-2.5 group">
            <img
              src="/logo-horizontal-white.png"
              alt="WebJesters"
              width="1600"
              height="333"
              className="h-7 w-auto transition-opacity group-hover:opacity-90"
            />
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-[13px] text-zinc-400 hover:text-white transition-colors"
          >
            <ArrowLeft size={14} weight="bold" />
            Back home
          </Link>
        </div>
      </header>

      <article className="max-w-[760px] mx-auto px-5 md:px-10 py-16 sm:py-24">
        <div className="text-[11px] tracking-[0.22em] uppercase text-zinc-400">{eyebrow}</div>
        <h1 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white leading-[1.05]">
          {title}
        </h1>
        {lastUpdated && (
          <div data-testid="legal-last-updated" className="mt-4 text-[12.5px] text-zinc-400">
            Last updated: {lastUpdated}
          </div>
        )}
        <div className="mt-12 legal-prose space-y-7 text-[15px] leading-[1.75] text-zinc-300">{children}</div>
      </article>

      <footer className="border-t border-white/[0.06] py-10">
        <div className="max-w-[760px] mx-auto px-5 md:px-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-[12.5px] text-zinc-400">
          <div>© {new Date().getFullYear()} WebJesters LLC.</div>
          <nav className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <Link to="/" className="hover:text-zinc-300 transition-colors">Home</Link>
            {LEGAL_LINKS.map((l) => (
              <Link key={l.to} to={l.to} className="hover:text-zinc-300 transition-colors">{l.label}</Link>
            ))}
            <button
              type="button"
              onClick={openCookieSettings}
              data-testid="legal-cookie-settings"
              className="hover:text-zinc-300 transition-colors"
            >
              Cookie settings
            </button>
          </nav>
        </div>
      </footer>
    </main>
  );
}

export function LegalSection({ title, id, children }) {
  return (
    <section id={id} className="scroll-mt-24">
      <h2 className="font-display text-xl sm:text-[22px] tracking-tight text-white mb-3">{title}</h2>
      <div className="space-y-4 text-zinc-300">{children}</div>
    </section>
  );
}

export const legalLink = "text-white underline underline-offset-4 hover:text-zinc-100";
